import EntityDialog from '../../EntityDialog';
import { useNavigate } from 'react-router-dom';
import { addOrganization } from '../../hooks/useOrganizations';
import { showToastError } from '../../components/ToastNotifications';
import { useLegacyAppSession } from '../../contexts/LegacyAppSessionContext';
import { getErrorMessage } from '../../utils/requestErrors';

export default function AddOrganizationContainer() {
  const navigate = useNavigate();
  const { changeOrganization } = useLegacyAppSession();

  return (
    <EntityDialog
      title="Add Organization"
      contextLabel="Organizations"
      fields={[{ name: 'name', label: 'Organization Name', required: true }]}
      initialValues={{ name: '' }}
      onClose={() => navigate('/organizations', { replace: true })}
      onSave={async (payload) => {
        try {
          const created = await addOrganization(payload.name);
          if (!created?.id || !created?.name) {
            throw new Error('The created organization was not returned.');
          }
          await changeOrganization({
            id: created.id,
            name: created.name,
          });
          navigate('/organizations', { replace: true });
        } catch (error) {
          showToastError(getErrorMessage(error, 'Organization could not be saved.'));
          console.error(error);
        }
      }}
    />
  );
}
